import React, { Component } from "react";
import NetflixTrayItem from "~/modules/Tray/Video/netflix-tray-item";
import { fetchSearchResults } from "~/modules/SearchResults/helpers";

import Spinner from "~/components/Spinner";

import "./SearchResults.css";

class SearchResults extends Component {
  state = {
    searchResults: [],
    resultsNumber: 0,
    isLoading: true,
    hasMadeQuery: false
  };
  componentDidMount() {
    fetchSearchResults().then(items => {
      if (!items) {
        this.setState({ isLoading: false, hasMadeQuery: false });
      } else {
        this.setState({
          searchResults: items,
          resultsNumber: items.length,
          isLoading: false,
          hasMadeQuery: true
        });
      }
    });
  }
  render() {
    const {
      searchResults,
      resultsNumber,
      isLoading,
      hasMadeQuery
    } = this.state;
    return isLoading ? (
      <div className="filter-search-spinner">
        <div>
          <Spinner />
        </div>
      </div>
    ) : hasMadeQuery ? (
      <div className="filter-search-results">
        <h1 className="filter-search-results-heading">
          <span className="filter-search-reasults-red">{`${resultsNumber}`}</span>{" "}
           workouts found based off your selection
        </h1>
        <div className="search-results-grid netflix-tray ">
          {searchResults.map((item, i) => (
            <NetflixTrayItem item={item} key={item.gist.id} noHover={true} />
          ))}
        </div>
      </div>
    ) : (
      <div className="filter-search-results-none">
        Use search bar or filters to search for workouts!
      </div>
    )
  }
}

export default SearchResults;
